<template>
  <v-form v-model="valid">
    <asc-text-field-input
      v-model="name"
      class="asc-airline-mgmt-form--row-text"
      required
      label="Airline Name"
      :counter="true"
      :max-length="50"
      :rules="validationRules.name"
    ></asc-text-field-input>
    <asc-text-field-input
      v-model="icaoCode"
      class="asc-airline-mgmt-form--row-text"
      required
      label="ICAO"
      :counter="true"
      :max-length="5"
      :rules="validationRules.icaoCode"
    ></asc-text-field-input>
    <asc-text-field-input
      v-model="iataCode"
      class="asc-airline-mgmt-form--row-text"
      label="IATA"
      :rules="validationRules.iataCode"
      :counter="true"
      :max-length="5"
    ></asc-text-field-input>
    <asc-text-field-input
      v-model="aviationWeekName"
      class="asc-airline-mgmt-form--row-text"
      label="Aviation Week Name"
      :counter="true"
      :max-length="50"
    ></asc-text-field-input>
    <asc-text-field-input
      v-model="cosmosURLCode"
      class="asc-airline-mgmt-form--row-text"
      label="Cosmos URL Code"
      :rules="validationRules.cosmosURLCode"
    ></asc-text-field-input>
    <asc-text-field-input
      v-model="ingestionCode"
      class="asc-airline-mgmt-form--row-text"
      label="Ingestion Code"
      :counter="true"
      :max-length="50"
      :rules="validationRules.ingestionCode"
    ></asc-text-field-input>

    <div class="asc-airline-mgmt-form--checkbox">
      <asc-checkbox
        v-model="isActive"
        label="Active"
        :checked="isActive"
      ></asc-checkbox>
    </div>
  </v-form>
</template>

<script>
import AscTextFieldInput from '@/components/atoms/AscTextFieldInput'
import AscCheckbox from '@/components/atoms/AscCheckbox'
import variables from '@/styles/_varsJs.scss'

export default {
  name: 'AscAirlineMgmtForm',

  components: {
    AscTextFieldInput,
    AscCheckbox,
  },

  props: {
    data: {
      type: Object,
      default: () => {},
    },
    color: {
      type: String,
      default: variables.gray700,
    },
    airlines: {
      type: Array,
      default: () => [],
    },
    edit: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      validationRules: {
        name: [
          v => (!!v && !!v.trim()) || 'Airline name is required',
          v => (v && !this.isDuplicateAirline) || 'Airline already exists',
        ],
        icaoCode: [
          v => !!v || 'ICAO Code is required',
          v => (v && this.hasSpaces(v)) || 'Remove spaces to submit',
          v => (v && !this.isDuplicateIcao) || 'ICAO Code already exists',
          v => (v && v.length <= 5) || 'A maximum of 5 characters is allowed',
        ],
        iataCode: [v => this.hasSpaces(v) || 'Remove spaces to submit'],
        cosmosURLCode: [v => this.hasSpaces(v) || 'Remove spaces to submit'],
        ingestionCode: [v => this.hasSpaces(v) || 'Remove spaces to submit'],
      },
      valid: false,
    }
  },
  computed: {
    name: {
      get() {
        return this.data?.name
      },
      set(val) {
        this.update({
          name: val,
        })
      },
    },
    icaoCode: {
      get() {
        return this.data?.icaoCode
      },
      set(val) {
        this.update({
          icaoCode: val,
        })
      },
    },
    iataCode: {
      get() {
        return this.data?.iataCode
      },
      set(val) {
        this.update({
          iataCode: val,
        })
      },
    },
    aviationWeekName: {
      get() {
        return this.data?.aviationWeekName
      },
      set(val) {
        this.update({
          aviationWeekName: val,
        })
      },
    },
    cosmosURLCode: {
      get() {
        return this.data?.cosmosURLCode
      },
      set(val) {
        this.update({
          cosmosURLCode: val,
        })
      },
    },
    ingestionCode: {
      get() {
        return this.data?.ingestionCode
      },
      set(val) {
        this.update({
          ingestionCode: val,
        })
      },
    },
    isActive: {
      get() {
        return this.data?.isActive
      },
      set(val) {
        this.update({
          isActive: val,
        })
      },
    },
    isDuplicateAirline() {
      const airlineList = this.edit
        ? this.airlines?.filter(item => item.id !== this.data.id)
        : this.airlines
      const duplicate = airlineList.find(
        item => item.name.toLowerCase() === this.data.name.toLowerCase(),
      )
      return !!duplicate
    },
    isDuplicateIcao() {
      const airlineList = this.edit
        ? this.airlines?.filter(item => item.id !== this.data.id)
        : this.airlines
      const duplicate = airlineList.find(
        item =>
          item.icaoCode?.toLowerCase() === this.data.icaoCode.toLowerCase(),
      )
      return !!duplicate
    },
  },

  watch: {
    valid: {
      handler(newValue) {
        this.$emit('isValid', newValue)
      },
    },
  },

  methods: {
    update(propToOverwrite) {
      const mergedInfo = {
        ...this.data,
        ...propToOverwrite,
      }
      this.$emit('update', mergedInfo)
    },
    hasSpaces(value) {
      return !/\s/.test(value)
    },
  },
}
</script>

<style lang="scss">
.asc-airline-mgmt-form {
  &--row {
    &-text {
      width: 100%;
      padding: 10px;
    }
  }

  &--checkbox {
    padding: 0 10px 10px 10px;

    & > .asc-checkbox > div > label {
      color: $gray-700;
    }
  }
}
</style>
